import React from 'react';
import { Button, Table, Header, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import ThreeColumnTableRow from '../CreateCourse/ThreeColumnTableRow';
import { fetchFaculties, fetchStudyCycle, fetchLanguages, fetchAllAcademicYears } from '../../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class DetailsBHS extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            implementation: this.props.implementation,
            organizationalUnits: this.props.organizationalUnits,
            studyCycles: this.props.studyCycles,
            allLanguages: this.props.allLanguages,
            academicYears: this.props.academicYears,
            name: '',
            ects: '',
            durationYear: '',
            durationSemester: '',
            academicYearStart: '',
            studyCycle: '',
            studyProgramOrganizationalUnits: '',
            languages: '',
            classificationOfQualification: '',
            description: '',
            details: '',
            enrollmentTerms: '',
            gradingScale: '',
            nextCycleEnrollmentPossibility: '',
            professionalStatus: '',
            studyGoals: '',
            studyOutcomes: '',
            additionalInformation: '',
            studyRules: '',
            additionalInformationSource: '',

            edit: false
        };
        this.onChange = this.onChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.edit = this.edit.bind(this);
    }


    onChange(keyName, value) {
        this.setState({ [keyName]: value });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    getOrgUnitName(id) {
        const { organizationalUnits } = this.state;
        const selected = organizationalUnits.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    getStudyCycleName(id) {
        const { studyCycles } = this.state;
        const selected = studyCycles.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    getAcademicYearName(id) {
        const { academicYears } = this.state;
        const selected = academicYears.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    getLanguageName(id) {
        const { allLanguages } = this.state;
        const selected = allLanguages.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    edit() {
        const {
             ects, durationYear, durationSemester, academicYearStart, studyCycle, studyProgramOrganizationalUnits, languages,
            implementation, name, classificationOfQualification, description, details, enrollmentTerms, gradingScale,
            nextCycleEnrollmentPossibility, professionalStatus, studyGoals, studyOutcomes, additionalInformation,
            studyRules, additionalInformationSource
        } = this.state;

        if (
             ects || durationYear || durationSemester || academicYearStart || studyCycle
            // || studyProgramOrganizationalUnits || languages
             || name || classificationOfQualification || description || details || enrollmentTerms || gradingScale ||
            nextCycleEnrollmentPossibility || professionalStatus || studyGoals || studyOutcomes || additionalInformation ||
            studyRules || additionalInformationSource) {
            this.setState({ edit: false });

            let editObj = { id: implementation.studyProgram.id, optlock: implementation.studyProgram.optLock, translations: null };

            if (name) editObj = { ...editObj, name };
            if (ects) editObj = { ...editObj, ects };
            if (durationYear) editObj = { ...editObj, durationYear };
            if (durationSemester) editObj = { ...editObj, durationSemester };
            if (academicYearStart) editObj = { ...editObj, academicYearStart };
            if (studyCycle) editObj = { ...editObj, studyCycle };
            // if (studyProgramOrganizationalUnits) editObj = { ...editObj, studyProgramOrganizationalUnits };
            // if (languages) editObj = { ...editObj, languages };
            if (classificationOfQualification) editObj = { ...editObj, classificationOfQualification };
            if (description) editObj = { ...editObj, description };
            if (details) editObj = { ...editObj, details };
            if (enrollmentTerms) editObj = { ...editObj, enrollmentTerms };
            if (gradingScale) editObj = { ...editObj, gradingScale };
            if (gradingScale) editObj = { ...editObj, gradingScale };
            if (nextCycleEnrollmentPossibility) editObj = { ...editObj, nextCycleEnrollmentPossibility };
            if (professionalStatus) editObj = { ...editObj, professionalStatus };
            if (studyGoals) editObj = { ...editObj, studyGoals };
            if (studyOutcomes) editObj = { ...editObj, studyOutcomes };
            if (additionalInformation) editObj = { ...editObj, additionalInformation };
            if (studyRules) editObj = { ...editObj, studyRules };
            if (additionalInformationSource) editObj = { ...editObj, additionalInformationSource };

            console.log('editObj', editObj);
            axios.put('study-programs/update-study-program', { ...editObj })
                .then((res) => {
                    this.setState(
                        { implementation: { ...this.state.implementation, studyProgram: res.data } },
                        () => {
                            localStorage.setItem('implementation', JSON.stringify(this.state.implementation));
                        }
                    );
                    toast('Izmjena implementacije studijskog programa je uspješno izvršena.');
                })
                .catch(err => {
                    console.log(err);
                    toast('Došlo je do greške! Izmjena podataka nije izvršena.');
                });
        } else {
            toast('Morate unijeti nove podatke ukoliko želite izvršiti izmjenu!');
        }
    }

    render() {
        const { implementation } = this.state;
        console.log('implementation', implementation);
        return (
            <div>
                <Table celled unstackable compact>
                    <Table.Header>
                        <Table.Row>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        <ThreeColumnTableRow
                            name="Naziv"
                            keyName="name"
                            value={implementation.studyProgram.name}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.name}
                        />
                        <ThreeColumnTableRow
                            name="ECTS"
                            keyName="ects"
                            value={implementation.studyProgram.ects}
                            onChange={this.onChange}
                            defValue={implementation.studyProgram.ects}
                            edit={this.state.edit}
                        />
                        <ThreeColumnTableRow
                            name="Trajanje (godine)"
                            keyName="durationYear"
                            value={implementation.studyProgram.durationYear}
                            onChange={this.onChange}
                            defValue={implementation.studyProgram.durationYear}
                            edit={this.state.edit}
                        />
                        <ThreeColumnTableRow
                            name="Trajanje (semestri)"
                            keyName="durationSemester"
                            value={implementation.studyProgram.durationSemester}
                            onChange={this.onChange}
                            defValue={implementation.studyProgram.durationSemester}
                            edit={this.state.edit}
                        />
                        <ThreeColumnTableRow
                            name="Akademska godina početka"
                            keyName="academicYearStart"
                            value={implementation.studyProgram.academicYearStart ? implementation.studyProgram.academicYearStart.name : null}
                            onChange={this.handleInputChange}
                            academicYears={this.props.academicYears}
                            defValue={implementation.studyProgram.academicYearStart ? implementation.studyProgram.academicYearStart.name : null}
                            edit={this.state.edit}
                        />
                        <ThreeColumnTableRow
                            name="Studijski ciklus"
                            keyName="studyCycle"
                            value={implementation.studyCycles ? implementation.studyCycles.map(el => (<div>{el.displayName} <br /></div>)) : null}
                            onChange={this.handleInputChange}
                            studyCycles={JSON.parse(localStorage.getItem('studyCycles'))}
                            defValue={implementation.studyCycles ? implementation.studyCycles.map(el => (<div>{el.displayName} <br /></div>)) : null}
                            edit={this.state.edit}
                        />
                        <ThreeColumnTableRow
                            name="Organizacione jedinice"
                            keyName="studyProgramOrganizationalUnits"
                            value={implementation.organizationalUnitDTOs.length ? implementation.organizationalUnitDTOs.map(el => (<div>{el.name} <br /></div>)) : null}
                            onChange={this.handleInputChange}
                            organizationalUnits={this.state.organizationalUnits}
                            defValue={implementation.organizationalUnitDTOs.length ? implementation.organizationalUnitDTOs.map(el => (<div>{el.name}<br /></div>)) : null}
                        />
                        <ThreeColumnTableRow
                            name="Titula"
                            keyName="titleName"
                            value={implementation.studyProgramTitle.name}
                            onChange={this.handleInputChange}
                            titles={this.props.titles}
                            defValue={implementation.studyProgramTitle.id}
                            edit={this.state.edit}
                        />
                        {/* <ThreeColumnTableRow */}
                        {/*    name="Jezici" */}
                        {/*    keyName="languages" */}
                        {/*    value={implementation.languageIds ? implementation.languageIds.map(el => (<div>{this.getLanguageName(el)} <br /></div>)) : null} */}
                        {/*    onChange={this.handleInputChange} */}
                        {/*    edit={this.state.edit} */}
                        {/*    languages={this.state.allLanguages} */}
                        {/*    defValue={implementation.languageIds ? implementation.languageIds[0] : null} */}
                        {/* /> */}

                        <ThreeColumnTableRow
                            name="Opis"
                            keyName="description"
                            value={implementation.studyProgram.description}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.description}
                        />
                        <ThreeColumnTableRow
                            name="Detalji"
                            keyName="details"
                            value={implementation.studyProgram.details}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.details}
                        />
                        <ThreeColumnTableRow
                            name="Klasifikacija kvalifikacija"
                            keyName="classificationOfQualification"
                            value={implementation.studyProgram.classificationOfQualification}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.classificationOfQualification}
                        />
                        <ThreeColumnTableRow
                            name="Uslovi upisa"
                            keyName="enrollmentTerms"
                            value={implementation.studyProgram.enrollmentTerms}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.enrollmentTerms}
                        />
                        <ThreeColumnTableRow
                            name="Pravila studiranja"
                            keyName="studyRules"
                            value={implementation.studyProgram.studyRules}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.studyRules}
                        />
                        <ThreeColumnTableRow
                            name="Skala ocjenjivanja"
                            keyName="gradingScale"
                            value={implementation.studyProgram.gradingScale}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.gradingScale}
                        />

                        <ThreeColumnTableRow
                            name="Mogućnost upisa na sljedeći ciklus"
                            keyName="nextCycleEnrollmentPossibility"
                            value={implementation.studyProgram.nextCycleEnrollmentPossibility}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.nextCycleEnrollmentPossibility}
                            textArea
                        />
                        <ThreeColumnTableRow
                            name="Profesionalni status"
                            keyName="professionalStatus"
                            value={implementation.studyProgram.professionalStatus}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.professionalStatus}
                            textArea
                        />

                        <ThreeColumnTableRow
                            name="Ciljevi učenja"
                            keyName="studyGoals"
                            value={implementation.studyProgram.studyGoals}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.studyGoals}
                            textArea
                        />
                        <ThreeColumnTableRow
                            name="Ishodi učenja"
                            keyName="studyOutcomes"
                            value={implementation.studyProgram.studyOutcomes}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.studyOutcomes}
                            textArea
                        />
                        <ThreeColumnTableRow
                            name="Dodatne informacije"
                            keyName="additionalInformation"
                            value={implementation.studyProgram.additionalInformation}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.additionalInformation}
                        />

                        <ThreeColumnTableRow
                            name="Izvor dodatnih informacija"
                            keyName="additionalInformationSource"
                            value={implementation.studyProgram.additionalInformationSource}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={implementation.studyProgram.additionalInformationSource}
                            textArea
                        />

                    </Table.Body>
                </Table>
                {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja' && localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' ) ? !this.state.edit ?
                    <Button floated="right" primary onClick={() => this.setState({ edit: true })}>Izmijeni</Button>
                    : <div><Button floated="right" basic="true" color="blue" onClick={() => this.setState({ edit: false })}>Odustani</Button>
                        <Button floated="right" primary onClick={this.edit}>Sačuvaj izmjene</Button>
                    </div>: ''}
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/DetailsBHS.js